<div class="expanded-nav">
  <div class="logo-row">
    <a routerLink="/home" class="brand">
      <img src="/machine-logo.png" alt="Machine Logo" class="site-logo">
      <span class="brand-name">The Machine</span>
    </a>
    <button class="toggle-btn" type="button" (click)="toggle.emit()" aria-label="Collapse side navigation">
      <i class="bi bi-chevron-double-left"></i>
    </button>
  </div>

  <div class="menu">
    @if (projectGroups.length) {
      <div class="group-title project-section">Project</div>
      @for (group of projectGroups; track group) {
        <div class="group pt-2">
          <button type="button" class="menu-item group-header" [class.active-group]="isGroupActive(group) && !expandedState[group.key]" (click)="toggleGroup(group.key)">
            <span class="label">{{ group.title }}</span>
            <i class="bi bi-chevron-right" [class.rotate]="expandedState[group.key]"></i>
          </button>
          @if (expandedState[group.key]) {
            <div class="group-items">
              @for (item of group.items; track item) {
                <a [routerLink]="item.route" routerLinkActive="active" class="menu-item">
                  <i [class]="item.icon"></i>
                  <span class="label">{{ item.title }}</span>
                </a>
              }
            </div>
          }
        </div>
      }
    }

    @if (organizationGroups.length) {
      <div class="group-title org-section">Organization</div>
      @for (group of organizationGroups; track group) {
        <div class="group pt-2">
          <button type="button" class="menu-item group-header" [class.active-group]="isGroupActive(group) && !expandedState[group.key]" (click)="toggleGroup(group.key)">
            <span class="label">{{ group.title }}</span>
            <i class="bi bi-chevron-right" [class.rotate]="expandedState[group.key]"></i>
          </button>
          @if (expandedState[group.key]) {
            <div class="group-items">
              @for (item of group.items; track item) {
                <a [routerLink]="item.route" routerLinkActive="active" class="menu-item">
                  <i [class]="item.icon"></i>
                  <span class="label">{{ item.title }}</span>
                </a>
              }
            </div>
          }
        </div>
      }
    }
  </div>

  <div class="footer">
    <a routerLink="/settings" routerLinkActive="active" class="menu-item">
      <i class="bi bi-gear"></i>
      <span class="label">Settings</span>
    </a>
    <a routerLink="/profile" routerLinkActive="active" class="menu-item">
      <i class="bi bi-person-circle"></i>
      <span class="label">Profile</span>
    </a>
    <button class="menu-item" type="button" (click)="logout.emit()">
      <i class="bi bi-box-arrow-right"></i>
      <span class="label">Logout</span>
    </button>
  </div>
</div>


